import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AlertController, IonPopover, PopoverController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { UserDto } from "../../../core/dto/user.dto";
import { ServerConnection } from "../../../core/http/serverConnection";
import { ServersConnectionsProvider } from "../../../core/providers/serversConnections.provider";
import { AttachmentService } from "../../../core/services/attachment.service";
import { OfflineModeService } from "../../../core/services/offlineMode.service";
import { UserService } from "../../../core/services/user.service";
import { LoadingHelper } from "../../../gyzmo-commons/helpers/loading.helper";
import { NavControllerExtended } from "../../../gyzmo-commons/helpers/navControllerExtended";
import { NetworkHelper } from "../../../gyzmo-commons/helpers/network.helper";
import { FileService } from "../../../gyzmo-commons/services/file.service";
import { LoggerService } from "../../../gyzmo-commons/services/logs/logger.service";

const DEMO_DATA_URL: string = "technical/scripts?zone=DEMO_DELIVERY&lpServices=true";

@Component({
    selector: "title-bar",
    templateUrl: "title-bar.component.html",
    styleUrls: ["title-bar.component.scss"],
})
export class TitleBarComponent {
    @ViewChild("popover", { static: false }) popover: IonPopover;

    @Input() title: string;
    @Input() icon: string;
    @Input() isTodayButtonVisible: boolean;
    @Input() isSwapButtonVisible: boolean;
    @Output() todayClick: EventEmitter<any> = new EventEmitter();
    @Output() swapClick: EventEmitter<any> = new EventEmitter();

    public isConnected = false;
    currentUser: UserDto;

    public nbClick: number = 0;

    private connectivitySubscription: Subscription;

    constructor(private networkHelper: NetworkHelper,
                private popoverController: PopoverController,
                private attachmentService: AttachmentService,
                private fileService: FileService,
                private translateService: TranslateService,
                private navCtrl: NavControllerExtended,
                private userService: UserService,
                private alertCtrl: AlertController,
                private logger: LoggerService,
                private loadingHelper: LoadingHelper,
                private serversConnectionsProvider: ServersConnectionsProvider,
                public offlineModeService: OfflineModeService) {
        this.isConnected = networkHelper.isConnected();
    }

    async ngOnInit() {
        this.connectivitySubscription = this.networkHelper.getConnectivityObservable()
            .subscribe((isConnected) => {
                this.isConnected = isConnected;
            });

        this.currentUser = await this.userService.getCurrentUserWithThirdPartyOnly();
    }

    ngOnDestroy() {
        this.connectivitySubscription.unsubscribe();
    }

    public async generateDemoData(nbClick: number) {
        this.nbClick = nbClick;
        if (this.nbClick > 2) {
            let serverConnections: ServerConnection = this.serversConnectionsProvider.getServerConnection();
            await this.loadingHelper.showLoading();
            serverConnections.post(this.constructor.name, DEMO_DATA_URL, null, {})
                .then(async () => {
                    await this.loadingHelper.hideAll();
                    this.nbClick = 0;
                })
                .catch((error) => {
                    this.nbClick = 0;
                });
        }
    }

    public disconnect() {
        void this.popoverController.getTop().then((element) => {
            void element.dismiss();
        });

        void this.alertCtrl.create({
            header: this.translateService.instant("IMCP_Logout"),
            message: this.translateService.instant("IMCP_Would_you_like_to_log_out?"),
            buttons: [{
                text: this.translateService.instant("IMCP_Cancel"),
                role: "cancel",
                handler: () => {
                    this.logger.info(this.constructor.name, "Disconnection prevented!");
                },
            },
                {
                    text: this.translateService.instant("IMCP_Confirm"),
                    handler: () => {
                        void this.userService.disconnect(true)
                            .then(value => {
                                void this.navCtrl.navigateRoot("connection");
                            });
                    },
                }],
        }).then(alert => alert.present());
    }

    public onTodayClick() {
        if (this.todayClick) {
            this.todayClick.emit();
        }
    }

    public onSwapButtonClick() {
        if (this.swapClick) {
            this.swapClick.emit();
        }
    }

    public openPopover($event) {
        void this.popover.present($event);
    }

    public async userManual() {
        let userManual = await this.attachmentService.getUserManual();
        void this.fileService.openDocument(userManual);
        void this.popoverController.getTop().then((element) => {
            void element.dismiss();
        });
    }

    public cgu() {
        void this.navCtrl.navigateForward("/cgu", { onlyReading: true });
        void this.popoverController.getTop().then((element) => {
            void element.dismiss();
        });
    }

    public privacyPolicy() {
        void this.navCtrl.navigateForward("/privacy-policy", { onlyReading: true });
        void this.popoverController.getTop().then((element) => {
            void element.dismiss();
        });
    }

    public about() {
        void this.navCtrl.navigateForward("/about/iMobDelivery");
        void this.popoverController.getTop().then((element) => {
            void element.dismiss();
        });
    }
}
